module.exports = __webpack_public_path__ + "static/media/roof-plan.898a7a18.svg";